import { Backend, OrderByDirection } from '@freelancer/datastore/core';

export function onlineOfflineBackend(): Backend<'onlineOffline'> {
  return {
    defaultOrder: { field: 'id', direction: OrderByDirection.DESC },
  };
}

export enum OnlineOfflineUserStatusValueApi {
  OFFLINE = 1,
  ONLINE = 2,
}
